(function () {
    'use strict';

    angular.module('eventDisplayApp', [
        'app.core',
    ]);

})();
